// @flow
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import { validatePassword, validatePasswordConfirmation } from '../validators';

declare var $: any;

export default class ResetPasswordFormView extends JQueryView {
  constructor() {
    super('#form_forgot_pass_edit');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.render();
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field1') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  render() {
    // コンポーネントデザインを利用するにあたってバリデーションエラーの表示の仕方を指定
    this.$el.validate({
      errorElement: 'div',
      errorPlacement: function(error, element) {
        element.addClass('is-invalid');
        error.addClass('invalid-feedback');
        error.appendTo(element.parents('.form-group'));
      },
    });
    validatePassword();
    validatePasswordConfirmation();
  }
}
